import PropTypes from "prop-types";
import { InputItem } from "pepsico-ds";
import { useCallback, useEffect, useState } from "react";
import ButtonGroupDynamic from "../../../../common/ButtonGroupDynamic";
import FiltersComponent from "../../../../common/filtersComponent/FiltersComponent";
import "./conditionFilters.scss";

export default function ConditionFilters({
  filterConfig,
  filterData,
  onFilterChange,
  onClear,
  onSearch,
  clearButtonText,
  showAllFilters,
}) {
  const [allFiltersData, setAllFiltersData] = useState(filterData);
  const [viewAllFilters, setViewAllFilters] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setAllFiltersData(filterData);
  }, [filterData]);

  const handleClear = useCallback(() => {
    setAllFiltersData({});
    setSearchTerm("");
    onSearch("");
    onClear();
  }, [onClear, onSearch]);

  const handleApply = useCallback(() => {
    onFilterChange(allFiltersData);
    setViewAllFilters(false);
  }, [allFiltersData, onFilterChange]);

  const handleSearchToggle = useCallback(() => {
    if (showSearch) {
      setSearchTerm("");
      onSearch("");
    }
    setShowSearch(!showSearch);
  }, [onSearch, showSearch]);

  const handleSearchChange = useCallback(
    (event) => {
      setSearchTerm(event.target.value);
      onSearch(event.target.value);
    },
    [onSearch]
  );

  return (
    <div className="condition-filters-wrapper">
      <FiltersComponent
        filterConfig={filterConfig}
        filterClasses="condition-filters"
        onFilterChange={onFilterChange}
        handleClearFilters={handleClear}
        handleApplyFilters={handleApply}
        viewAllFilters={viewAllFilters}
        setViewAllFilters={setViewAllFilters}
        showAllFiltersOption
        enableAllFiltersButton={showAllFilters}
        debouncedFilterFormData={filterData}
        handleDebouncedFilterChange={onFilterChange}
        filterData={filterData}
        allFiltersData={allFiltersData}
        handleAllFiltersChange={setAllFiltersData}
        clearButtonText={clearButtonText}
      />
      <div className="condition-filters-wrapper__listing-actions">
        {showSearch && (
          <InputItem
            aria-label="Search listing"
            className="condition-filters-wrapper__search"
            placeholder="Search"
            size="small"
            trailingIcon="search"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        )}
        <ButtonGroupDynamic
          items={[
            {
              icon: "search",
              onClick: handleSearchToggle,
            },
          ]}
          size="medium"
          spacing="2px"
          variant="control"
          selectedIndex={-1}
        />
      </div>
    </div>
  );
}

ConditionFilters.propTypes = {
  filterConfig: PropTypes.shape({
    withoutDebounce: PropTypes.shape({
      jsonSchema: PropTypes.object,
      uiSchema: PropTypes.object,
    }),
    allFilters: PropTypes.shape({
      jsonSchema: PropTypes.object,
      uiSchema: PropTypes.object,
    }),
  }).isRequired,
  filterData: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  clearButtonText: PropTypes.string,
  showAllFilters: PropTypes.bool,
};

ConditionFilters.defaultProps = {
  clearButtonText: undefined,
  showAllFilters: false,
};
